export const getTotalFilters = ({
  selectedFloorplanIds,
  startMoveInDate, endMoveInDate,
  startMoveOutDate, endMoveOutDate,
  selectedTagIds,
}) => {

  let total = 0;

  const filters = [selectedTagIds?.length > 0, selectedFloorplanIds?.length > 0, startMoveInDate || endMoveInDate, startMoveOutDate || endMoveOutDate]
  filters.forEach((item) => {
    if (item) total += 1;
  });

  return total;
}